import { colors } from "./palette";
import typography from "./typography";
import sizeOverrides from "./sizeOverrides";

const components = {
  MuiCssBaseline: {
    styleOverrides: {
      "ul, ol": {
        listStyle: "none",
        padding: 0,
      },
      "::-webkit-scrollbar": {
        width: "4px",
        height: "4px",
      },
      "::-webkit-scrollbar-track": {
        backgroundColor: "#f1f1f1",
      },
      "::-webkit-scrollbar-thumb": {
        backgroundColor: "#888",
      },
      "::-webkit-scrollbar-thumb:hover": {
        backgroundColor: "#555",
      },
    },
  },

  MuiTypography: {
    defaultProps: {
      variantMapping: {
        h1ExtraBold: "h1",
        h2ExtraBold: "h2",
        h3ExtraBold: "h3",
        h3Bold: "h3",
        h4ExtraBold: "h4",
        h5Bold: "h5",
      },
    },
  },

  MuiButton: {
    styleOverrides: {
      root: {
        borderRadius: "50px",
        boxShadow: "none",
        WhiteSpace: "nowrap",
        columnGap: "4px",
        textTransform: "none",
        "& .MuiButton-endIcon, & .MuiButton-startIcon": {
          margin: 0,
        },
      },
    },
    variants: [
      {
        props: { variant: "primary-sm" },
        style: {
          ...sizeOverrides.sm,
          backgroundColor: colors.Green100,
          color: colors.White,
          padding: "8px 14px",
          fontSize: "14px",

          "&:hover": {
            backgroundColor: colors.Green200,
          },
          "&:disabled": {
            backgroundColor: colors.Green25,
            color: colors.White,
          },
        },
      },
      {
        props: { variant: "primary-md" },
        style: {
          ...sizeOverrides.md,
          backgroundColor: colors.Green100,
          color: colors.White,
          padding: "10px 16px",
          fontSize: "14px",
          "&:hover": {
            backgroundColor: colors.Green200,
          },
          "&:disabled": {
            backgroundColor: colors.Green25,
            color: colors.White,
          },
        },
      },
      {
        props: { variant: "primary-lg" },
        style: {
          ...sizeOverrides.lg,
          backgroundColor: colors.Green100,
          color: colors.White,
          padding: "10px 18px",
          fontSize: "16px",
          "&:hover": {
            backgroundColor: colors.Green200,
          },
          "&:disabled": {
            backgroundColor: colors.Green25,
            color: colors.White,
          },
        },
      },
      {
        props: { variant: "primary-xl" },
        style: {
          ...sizeOverrides.xl,
          backgroundColor: colors.Green100,
          color: colors.White,
          padding: "12px 20px",
          fontSize: "16px",
          "&:hover": {
            backgroundColor: colors.Green200,
          },
          "&:disabled": {
            backgroundColor: colors.Green25,
            color: colors.White,
          },
        },
      },

      // Outlined Button Variants
      {
        props: { variant: "outlined-sm" },
        style: {
          ...sizeOverrides.sm,
          backgroundColor: "transparent",
          border: `1px solid ${colors.Green100}`,
          color: colors.Green100,
          padding: "8px 14px",
          fontSize: "14px",
          "&:hover": {
            backgroundColor: colors.Green25,
            borderColor: colors.Green200,
            color: colors.Green200,
          },
          "&:disabled": {
            borderColor: colors.Green25,
            color: colors.Green25,
          },
        },
      },
      {
        props: { variant: "outlined-md" },
        style: {
          ...sizeOverrides.md,
          backgroundColor: "transparent",
          border: `1px solid ${colors.Green100}`,
          color: colors.Green100,
          padding: "10px 16px",
          fontSize: "14px",
          "&:hover": {
            backgroundColor: colors.Green25,
            borderColor: colors.Green200,
            color: colors.Green200,
          },
          "&:disabled": {
            borderColor: colors.Green25,
            color: colors.Green25,
          },
        },
      },
      {
        props: { variant: "outlined-lg" },
        style: {
          ...sizeOverrides.lg,
          backgroundColor: "transparent",
          border: `1px solid ${colors.Green100}`,
          color: colors.Green100,
          padding: "10px 18px",
          fontSize: "16px",
          "&:hover": {
            backgroundColor: colors.Green25,
            borderColor: colors.Green200,
            color: colors.Green200,
          },
          "&:disabled": {
            borderColor: colors.Green25,
            color: colors.Green25,
          },
        },
      },
      {
        props: { variant: "outlined-xl" },
        style: {
          ...sizeOverrides.xl,
          backgroundColor: "transparent",
          border: `1px solid ${colors.Green100}`,
          color: colors.Green100,
          padding: "12px 20px",
          fontSize: "16px",
          "&:hover": {
            backgroundColor: colors.Green25,
            borderColor: colors.Green200,
            color: colors.Green200,
          },
          "&:disabled": {
            borderColor: colors.Green25,
            color: colors.Green25,
          },
        },
      },

      // Text Button Variants
      {
        props: { variant: "text-sm" },
        style: {
          ...sizeOverrides.sm,
          backgroundColor: "transparent",
          color: colors.Green100,
          padding: "8px 14px",
          fontSize: "14px",
          "&:hover": {
            backgroundColor: colors.Green25,
            color: colors.Green100,
          },
          "&:disabled": {
            color: colors.Green25,
          },
        },
      },
      {
        props: { variant: "text-md" },
        style: {
          ...sizeOverrides.md,
          backgroundColor: "transparent",
          color: colors.Green100,
          padding: "10px 16px",
          fontSize: "14px",
          "&:hover": {
            backgroundColor: colors.Green25,
            color: colors.Green100,
          },
          "&:disabled": {
            color: colors.Green25,
          },
        },
      },
      {
        props: { variant: "text-lg" },
        style: {
          ...sizeOverrides.lg,
          backgroundColor: "transparent",
          color: colors.Green100,
          padding: "10px 18px",
          fontSize: "16px",
          "&:hover": {
            backgroundColor: colors.Green25,
            color: colors.Green100,
          },
          "&:disabled": {
            color: colors.Green25,
          },
        },
      },
      {
        props: { variant: "text-xl" },
        style: {
          ...sizeOverrides.xl,
          backgroundColor: "transparent",
          color: colors.Green100,
          padding: "12px 20px",
          fontSize: "16px",
          "&:hover": {
            backgroundColor: colors.Green25,
            color: colors.Green100,
          },
          "&:disabled": {
            color: colors.Green25,
          },
        },
      },

      // Secondary Button Variants
      {
        props: { variant: "secondary-sm" },
        style: {
          ...sizeOverrides.sm,
          backgroundColor: colors.Green25,
          color: colors.Green100,
          padding: "8px 14px",
          fontSize: "14px",
          "&:hover": {
            backgroundColor: "transparent",
            border: `1px solid ${colors.Green50}`,
          },
          "&:disabled": {
            backgroundColor: colors.Green25,
            color: colors.White,
          },
          "&:disabled .MuiButton-icon .MuiSvgIcon-root": {
            color: colors.White,
            fill: colors.White,
          },
          "&:disabled .MuiButton-icon .MuiSvgIcon-root path": {
            color: colors.White,
            fill: colors.White,
            stroke: colors.White,
          },
        },
      },
      {
        props: { variant: "secondary-md" },
        style: {
          ...sizeOverrides.md,
          backgroundColor: colors.Green25,
          color: colors.Green100,
          padding: "10px 16px",
          fontSize: "14px",
          "&:hover": {
            backgroundColor: "transparent",
            border: `1px solid ${colors.Green50}`,
          },
          "&:disabled": {
            backgroundColor: colors.Green25,
            color: colors.White,
          },
        },
      },
      {
        props: { variant: "secondary-lg" },
        style: {
          ...sizeOverrides.lg,
          backgroundColor: colors.Green25,
          color: colors.Green100,
          padding: "10px 18px",
          fontSize: "16px",
          "&:hover": {
            backgroundColor: "transparent",
            border: `1px solid ${colors.Green50}`,
          },
          "&:disabled": {
            backgroundColor: colors.Green25,
            color: colors.White,
          },
        },
      },
      {
        props: { variant: "secondary-xl" },
        style: {
          ...sizeOverrides.xl,
          backgroundColor: colors.Green25,
          color: colors.Green100,
          padding: "12px 20px",
          fontSize: "16px",
          "&:hover": {
            backgroundColor: "transparent",
            border: `1px solid ${colors.Green50}`,
          },
          "&:disabled": {
            backgroundColor: colors.Green25,
            color: colors.White,
          },
        },
      },
    ],
    defaultProps: {
      disableElevation: true,
      disableFocusRipple: true,
      disableRipple: true,
    },
  },

  MuiOutlinedInput: {
    styleOverrides: {
      root: {
        borderRadius: "8px",
        border: `1px solid ${colors.Gray200}`,
        padding: "0 16px",

        "&:has(.MuiSelect-select)": {
          borderRadius: "50px",
        },
        "& .MuiSelect-select": {
          ...typography.body14Regular,
          padding: "10px 32px 10px 0",
          color: colors.Gray400,
        },
      },
    },
  },

  MuiTextField: {
    styleOverrides: {
      root: {
        color: colors.Black100,
        ...typography.body14Regular,

        "& .MuiInputBase-input": {
          padding: "8px 0",
        },
        "& .MuiInputBase-input::placeholder": {
          color: colors.Gray400,
        },
        "& .MuiFormHelperText-root ": {
          ...typography.body14Regular,
          color: colors.dark600,
        },
        "& .MuiOutlinedInput-root": {
          borderRadius: "50px",
          border: `1px solid ${colors.Gray200}`,
          padding: "0 12px !important",
        },
        "& .Mui-focused": {
          borderColor: `${colors.Green50} !important`,
        },
        "& .Mui-disabled": {
          backgroundColor: `${colors.Gray50} !important`,
        },
        "& .Mui-error": {
          borderColor: `${colors.red100} !important`,
        },
      },
    },
    variants: [],
  },

  MuiAutoComplete: {
    styleOverrides: {
      root: {
        "& .MuiInputBase-root": {},
      },
    },
  },

  MuiPopper: {
    styleOverrides: {
      root: {
        width: "fit-content !important",
      },
    },
  },

  MuiSlider: {
    styleOverrides: {
      thumb: {
        height: "18px",
        width: "18px",
        backgroundColor: colors.White,

        boxShadow: `0 0 0 1px ${colors.Gray200}`,

        "&::before": {
          content: '""',
          height: "9px",
          width: "9px",
          backgroundColor: colors.Green100,
          borderRadius: "50%",
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
        },
      },
    },
  },
};

export default components;
